import { TO_START_LOADER } from "../../actions/action.types";

const startLoader = (state = false, action: any) => {
  if (action.type === TO_START_LOADER) return action.payload;
  else return state;
};

export default startLoader;
